import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { useAnimation, motion } from "framer-motion";
import Notice from "./Notice";

const SchoolInfo = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  const animation = useAnimation();

  const variants = {
    visible: { opacity: 1, scale: 1 },
    hidden: {
      opacity: 0,
      scale: 0.1,
      // y: 150,
    },
  };

  const variants2 = {
    visible: { opacity: 1, y: 0 },
    hidden: {
      opacity: 0,
      y: 50,
    },
    transition: {
      type: "spring",
      bounce: 1,
    },
  };

  const variants3 = {
    visible: { opacity: 1, y: 0 },
    hidden: {
      opacity: 0,
      y: 30,
    },
  };

  useEffect(() => {
    if (inView) {
      animation.start({
        opacity: 1,
        scale: 1,
        y: 0,
        // transition: {
        //   type: "spring",
        //   duration: 1,
        //   bounce: 0.3,
        // },
      });
    }
    if (!inView) {
      animation.start({
        opacity: 0,
        scale: 0,
        y: 50,
      });
    }
  }, [inView, animation]);

  return (
    <div className="flex flex-col items-center md:items-stretch md:flex-row p-2 md:p-6">
      <div
        ref={ref}
        className="w-full md:w-1/2 mx-2 text-sm font-serif p-4 bg-green-100"
      >
        <motion.h1
          animate={inView ? "visible" : "hidden"}
          variants={variants2}
          transition={{ duration: 0.7, ease: "easeIn" }}
          className="text-2xl text-center"
        >
          Principal's Message
        </motion.h1>
        <motion.p
          animate={inView ? "visible" : "hidden"}
          variants={variants2}
          transition={{ duration: 0.7, ease: "easeIn", delay: 0.2 }}
          className="mt-6"
        >
          Dear parents, students and well-wishers,
        </motion.p>
        <br />
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants2}
          transition={{ duration: 0.7, ease: "easeIn", delay: 0.2 }}
        >
          Welcome to Saint John’s High School website. As principal, I am
          impressed by your courtesy to go through our school website. Please
          remember, we, the management and the staff, are all set for an
          excellent all-round education of our beloved students at any cost.
        </motion.div>
        <br />
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants2}
          transition={{ duration: 0.7, ease: "easeIn", delay: 0.3 }}
        >
          Under my leadership, with my dedicated management, staffs, together
          with parents, strongly promote academic achievement among our
          students. We make special effort and emphasis on
          co-curricular/extra-curricular activities to identify students’
          capabilities according to their talents.
        </motion.div>
        <br />
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants2}
          transition={{ duration: 0.7, ease: "easeIn", delay: 0.4 }}
        >
          In-fact, school is the second home of our students and teachers are
          the second parents (Gurus). With this strong bond of love for the
          students and responsibility towards them, we leave “No Stone Unturned”
          to provide excellent inclusive education and impart proper moral
          discipline.
        </motion.div>
        <br />
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants2}
          transition={{ duration: 0.7, ease: "easeIn", delay: 0.5 }}
        >
          We have NO any distinction among the students based on gender, caste,
          creed, ethnicity and religion etc but to treat them as the treasure
          and hope of future India. With a long and rewarding history of
          achievement in education, sports and culture behind us, our school
          continues to move forward with confidence, pride and enthusiasm.
        </motion.div>
        <br />
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants2}
          transition={{ duration: 0.7, ease: "easeIn", delay: 0.6 }}
        >
          I hope you enjoy your visit to our school website
        </motion.div>
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants2}
          transition={{ duration: 0.7, ease: "easeIn", delay: 0.7 }}
          className="text-right my-4"
        >
          <p>Yours in educational service</p>
          <p>(Kulandai Swami)</p>
          <p>Principal</p>
          <p>Saint John’s High School</p>
          <p>Udaipur, Gomati Tripura.</p>
        </motion.div>
      </div>
      {/** Timings */}
      <div className=" bg-yellow-100 w-full md:w-1/2 font-serif p-6">
        {/** Timings  */}
        <div>
          <div className="">
            <h1 className="text-xl font-semibold">OFFICE HOURS</h1>
            <p>Principal's Office: 08:00am to 10:00am</p>
            <p>School Office: 08:00am to 10:00am</p>
            <p>11:00am - 12 Noon</p>
          </div>
          <div>
            <h1 className="text-xl font-semibold">SCHOOL HOURS</h1>
            <p>
              Nursery, KG.I, KG.II, Class-I, II, III & IV: 7:00am to 10:15am
            </p>
          </div>
        </div>
        {/** Notice Board */}
        <div className="mt-6">
          <Notice />
        </div>
      </div>
    </div>
  );
};

export default SchoolInfo;
